import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import { useNavigate } from "react-router-dom";

//PROJECT IMPORTS
// import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "./interestRate.config";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const NewInterestRate = (props) => {
  //DECLARED VARIABLES
  const {
    userData,
    onSelectItemAction,
    rightBtn,
    rightAction,
    getGlListAction,
  } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newInterestRateItems } = staticConfig;
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // getTemplate();
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
  }, []);

  function onCancel() {
    navigate("/prd0605", { replace: false });
  }

  const onSubmit = (formValues) => {
    // formValues.transactionDate = BOM.DateTime(formValues.transactionDate, "only-date")
    let tempPeriod = [];
    formValues?.ratePeriods?.forEach((element) => {
      tempPeriod.push({
        ...element,
        fromDate: BOM.DateTime(element.fromDate, "only-date"),
        dateFormat: "dd MMMM yyyy",
        locale: "en",
      });
    });

    formValues.ratePeriods = tempPeriod;

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.Floatingrates,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newFloatingRateMsg);
          navigate("/prd0605");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd0605");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newFloatingRate}
        pageItems={staticConfig.newFloatingRateItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: false,
              isBaseLendingRate: false,
            }}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.floatingRateSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.generalInfo}
              </Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.floatingRateName}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.floatingRateName),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.floatingRateName
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.status} name="isActive">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.status}`,
                      "select"
                    )}
                    options={staticConfig.statusData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.isBaseLendingRate}
                  name="isBaseLendingRate"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.isBaseLendingRate}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.floatingRatePeriodInfo}
              </Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.List name="ratePeriods">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{
                            display: "flex",
                            marginBottom: 8,
                          }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "fromDate"]}
                            rules={[
                              {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.fromDate),
                              },
                            ]}
                          >
                            <DatePicker
                              style={{ width: "100%", height: 35 }}
                              className="bond-date-picker"
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "interestRate"]}
                            rules={[
                              {
                                required: true,
                                message: BOM.CheckReqFld(
                                  labelConfig.floatingRate
                                ),
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder={labelConfig.floatingRate}
                              style={styles.ofInputFieldNumber}
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "isDifferentialToBaseLendingRate"]}
                          >
                            <Select
                              placeholder={labelConfig.isDifferential}
                              options={staticConfig.yesOrNoData}
                              showSearch
                            />
                          </Form.Item>
                          <CloseCircleFilled
                            style={{
                              color: "#92428B",
                              fontSize: "25px",
                              fontWeight: "bolder",
                            }}
                            onClick={() => remove(name)}
                          />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                          style={{
                            backgroundColor: "#15CCAE",
                            color: "white",
                            minWidth: "120px",
                            maxWidth: "100%",
                            width: "auto",
                            padding: "0 16px",
                            height: "auto",
                            minHeight: "32px",
                            marginBottom: 20,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "clamp(12px, 2.5vw, 14px)",
                            lineHeight: "1.2",
                          }}
                          className="responsive-button"
                        >
                          <span
                            style={{
                              display: "inline-block",
                              maxWidth: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {labelConfig.addFloatingPeriod}
                          </span>
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_FLOATINGRATE") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewInterestRate);
